import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageKeys } from "../core";

const initialState = {
  isLoggedIn: localStorage.getItem(LocalStorageKeys.clientToken) ? true : false,
  client: null,
  token: localStorage.getItem(LocalStorageKeys.clientToken),
  isLoading: false,
  profile: null,
  clients: [],
  report: {},
  summary: {},
};

const clientReducerSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    changeLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },

    addClientsState: (state, action) => {
      state.clients.unshift(action.payload);
      state.isLoading = false;
    },

    clientLoginState: (state, action) => {
      state.isLoggedIn = true;
      state.isLoading = false;
      localStorage.setItem(LocalStorageKeys.clientToken, action.payload);
    },

    clientLogoutState: (state) => {
      localStorage.removeItem(LocalStorageKeys.clientToken);
      state = {
        isLoggedIn: false,
        client: null,
        token: null,
      };
    },

    clientProfile: (state, action) => {
      state.profile = action.payload;
      state.isLoading = false;
    },

    clientReport: (state, action) => {
      state.report = action.payload;
      state.isLoading = false;
    },

    clientsummary: (state, action) => {
      state.summary = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  changeLoadingState,
  addClientsState,
  clientLoginState,
  clientLogoutState,
  clientProfile,
  clientReport,
  clientsummary,
} = clientReducerSlice.actions;

export default clientReducerSlice.reducer;
